import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-list-business-users',
  templateUrl: './list-business-users.component.html',
  styleUrls: ['./list-business-users.component.scss']
})
export class ListBusinessUsersComponent implements OnInit {

  public items: BusinessUser[];
  public displayedColumns: string[] = ['id','name', 'mobile', 'email', 'business_id', 'options'];

  constructor(
    private router: Router,
    public api: MgService,
  ) { }

  ngOnInit(): void {
    this.api.listAllUser().subscribe(res => this.items = res.data);
  }

  public goToAddUser(): void {
    this.router.navigate(['/operador/usuarios/adicionar'])
  }

  public editUser(){
    this.router.navigate(['/operador/usuarios/editar'])
  }
}
